import { useAuth } from "@/auth";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import CheckoutNavbar from "./checkoutNavbar";
import CookieBanner from "./misc/CookieBanner";
import CountdownBanner from "./CountdownBanner";
import GiftCardBanner from "./GiftCardBanner";

interface CheckoutLayoutProps {
  children: JSX.Element;
  className?: string;
}

export const getLatestRouteBeforeLogin = () => {
  return latestRouteBeforeLogin;
};

let latestRouteBeforeLogin = "/";

const CheckoutLayout = (props: CheckoutLayoutProps) => {
  const { auth, loading, isAuthenticated } = useAuth();
  const [showNotLoggedIn, setShowNotLoggedIn] = useState(false);
  const router = useRouter();
  const [seed, setSeed] = useState(1);

  useEffect(() => {
    if (!loading && !isAuthenticated) {
      setShowNotLoggedIn(true);
    }
  }, [loading, isAuthenticated]);

  return (
    <div key={seed} style={{ minHeight: "100vh" }}>
      {/* <CountdownBanner /> */}
      {/* <GiftCardBanner /> */}

      <CheckoutNavbar
        // onLangChange={() => {
        //   // props.children.key = 1;
        //   window.location.reload();
        //   setSeed(Math.random());
        // }}
        onLangChange={() => {
          const url = new URL(window.location.href);
          url.searchParams.delete('locale');
          window.location.href = url.toString();
        }}
      />
      <div
        className={"m-auto bg-white " + (props.className ?? "")}
        style={{ minHeight: window.innerHeight - 72 }}
      >
        <main
          className={"flex-grow col-span-2 "}
          style={{
            marginLeft: "auto",
            marginRight: "auto",
            paddingBottom: 48,
          }}
        >
          {props.children}
        </main>
        <CookieBanner />
      </div>
    </div>
  );
};

export default CheckoutLayout;
